import { render, staticRenderFns } from "./YearEdit.vue?vue&type=template&id=637b06d1"
import script from "./YearEdit.vue?vue&type=script&lang=js"
export * from "./YearEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports